export default String.raw`
<div class="page-padding">
    <h1 class="refunds-page-title refunds-initial-view-js">{{ translations.Returns }}</h1>

    <section class="refunds-container refunds-initial-view-js">
        <div class="refunds-info">
            <h2 class="refunds-info__title">{{ translations.ReturnInThreeSteps }}</h2>
            <p class="refunds-info__intro">{{ translations.ReturnWithoutReasonInfo }}</p>
            <ol class="refunds-steps">
                <li class="refunds-steps__item">
                    <span class="refunds-steps__number">1</span>
                    <p class="refunds-steps__text"><strong>{{ translations.LogIn }}</strong> {{ translations.OrEnterOrderNumber }}</p>
                </li>
                <li class="refunds-steps__item">
                    <span class="refunds-steps__number">2</span>
                    <p class="refunds-steps__text"><strong>{{ translations.FillForm }}</strong> {{ translations.ReturnOnline }}</p>
                </li>
                <li class="refunds-steps__item">
                    <span class="refunds-steps__number">3</span>
                    <p class="refunds-steps__text"><strong>{{ translations.SendParcel }}</strong> - {{ translations.SendParcelToOurAddress }}</p>
                </li>
            </ol>
            <p class="refunds-info__hint">{{ translations.FastSimpleSecure }}</p>
        </div>
        <div class="refunds-cta">
            <div class="refunds-cta__header">
                <h3 class="refunds-cta__title">{{ translations.ReadyForReturn }}</h3>
                <p class="refunds-cta__description">{{ translations.ReadyForReturnInfo }}</p>
            </div>
            {% if usr.Authenticated -%}
                <a href="{{ page.BaseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=orders" class="primary-action-button refunds-cta__button" rel="nofollow" aria-label="{{ translations.StartReturn }}">
                    {{ translations.StartReturn }}
                </a>
            {% else -%}
                <button type="button" class="primary-action-button refunds-cta__button start-refund-js" aria-label="{{ translations.StartReturn }}">
                    {{ translations.StartReturn }}
                </button>
            {% endif -%}
        </div>
    </section>

    {% unless usr.Authenticated -%}
    <section class="refund-form-section refund-form-view-js hidden-js">
        <div class="refund-form">
            <div class="refund-form__header">
                <h2 class="refund-form__title">{{ translations.ProductReturn }}</h2>
                <p class="refund-form__description">{{ translations.ProductReturnFormInfo }}</p>
            </div>
            <form class="refund-form__body refund-form-js" novalidate data-error="{{ translations.RefundLookupError }}">
                <div class="form__input-wrapper">
                    <label for="refundOrderNumber" class="form__input-info input-info-js">{{ translations.NumberOfOrder }}</label>
                    <input id="refundOrderNumber" type="text" name="orderNumber" class="form__input-value input-value-js" maxlength="50" required>
                    <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
                </div>
                <div class="form__input-wrapper">
                    <label for="refundEmail" data-type="email" class="form__input-info input-info-js">{{ translations.EmailAddress }}</label>
                    <input id="refundEmail" type="email" name="email" class="form__input-value input-value-js" maxlength="192" autocomplete="email" required>
                    <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
                    <div class="form__invalid-input validation-info-js email-valid-js hidden-js">{{ translations.FillProperEmail }}</div>
                </div>
                <button type="button" class="primary-action-button refund-form__submit refund-form-submit-js">
                    {{ translations.FindOrder }}
                </button>
                <p class="refund-form__login-info">
                    {{ translations.HaveAccount }} <a class="refund-form__login-link show-login-popup-js" rel="nofollow" tabindex="0" role="button">{{ translations.LogIn }},</a> {{ translations.LoginToSeeOrdersAndReturn }}
                </p>
            </form>
        </div>
    </section>
    {% endunless -%}
</div>
`